import { GameNotFoundComponent } from './../games/game-not-found/game-not-found.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, GamesGuard, NoStudentGamesGuard, UserTypeGuard } from '@core/guards';
import { GamesAvailableGuard } from '@core/guards/games-available.guard';
import { SubscriptionGuard } from '@core/guards/subscription.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('../home/home.module').then((mod) => mod.HomeModule),
  },
  {
    path: 'test-view2',
    loadChildren: () => import('../test-view/test-view.module').then((mod) => mod.TestViewModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('../profile/profile.module').then((mod) => mod.ProfileModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'games',
    loadChildren: () => import('../games/games.module').then((mod) => mod.GamesModule),
    canActivate: [AuthGuard, NoStudentGamesGuard, GamesAvailableGuard],
  },
  {
    path: 'game-not-found',
    component: GameNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'material',
    loadChildren: () =>
      import('../methodological-material/methodological-material.module').then(
        (mod) => mod.MethodologicalMaterialModule,
      ),
    canActivate: [AuthGuard, UserTypeGuard],
    data: {
      userTypes: ['teacher', 'admin', 'moderator'],
    },
  },
  {
    path: 'exercises',
    loadChildren: () => import('../exercises/exercises.module').then((mod) => mod.ExercisesModule),
    canActivate: [AuthGuard, UserTypeGuard, SubscriptionGuard],
    data: {
      userTypes: ['student'],
    },
  },
  {
    path: 'my-stats',
    loadChildren: () => import('../my-stats/my-stats.module').then((mod) => mod.MyStatsModule),
  },
  {
    path: 'support',
    loadChildren: () => import('../support/support.module').then((mod) => mod.SupportModule),
  },
  {
    path: 'rating',
    loadChildren: () => import('../rating/rating.module').then((mod) => mod.RatingModule),
  },
  {
    path: 'homeworks',
    loadChildren: () => import('../../pages-v3/homeworks/homeworks.module').then((mod) => mod.HomeworksModule),
    canActivate: [AuthGuard, UserTypeGuard, SubscriptionGuard, GamesAvailableGuard],
    canActivateChild: [GamesAvailableGuard],
    data: {
      userTypes: ['teacher'],
    },
  },
  {
    path: 'groups',
    loadChildren: () => import('../groups/groups.module').then((mod) => mod.GroupsModule),
    canActivate: [AuthGuard, SubscriptionGuard],
    // redirectTo: '/crm/data/groups',
  },
  {
    path: 'students',
    loadChildren: () => import('../students/students.module').then((mod) => mod.StudentsModule),
    canActivate: [AuthGuard, SubscriptionGuard],
    // redirectTo: '/crm/data/students',
  },
  // {
  //   path: 'teachers',
  //   // loadChildren: () =>
  //   //   import('../teachers/teachers.module').then((mod) => mod.TeachersModule),
  //   redirectTo: '/crm/data/teachers',
  // },
  {
    path: 'schedule',
    loadChildren: () => import('../schedule/schedule.module').then((mod) => mod.ScheduleModule),
    canActivate: [AuthGuard, SubscriptionGuard],
  },
  {
    path: 'subjects',
    loadChildren: () => import('../subjects/subjects.module').then((mod) => mod.SubjectsModule),
  },
  {
    path: 'rooms',
    loadChildren: () => import('../rooms/rooms.module').then((mod) => mod.RoomsModule),
  },
  {
    path: 'teachers',
    loadChildren: () => import('../teachers/teachers.module').then((mod) => mod.TeachersModule),
  },
  {
    path: 'salary_patterns',
    loadChildren: () =>
      import('../salary-patterns/salary-patterns.module').then((mod) => mod.SalaryPatternsModule),
  },
  {
    path: 'colors',
    loadChildren: () => import('../colors/colors.module').then((mod) => mod.ColorsModule),
  },
  {
    path: 'generator-templates',
    loadChildren: () =>
      import('../menar-generator/generator.module').then((m) => m.MenarGeneratorModule),
    canActivate: [UserTypeGuard],
    data: {
      userTypes: ['teacher'],
    },
  },
  {
    path: 'training-centers',
    loadChildren: () =>
      import('../training-centers/training-centers.module').then(
        (mod) => mod.TrainingCentersModule,
      ),
    canActivate: [AuthGuard, UserTypeGuard],
    data: {
      userTypes: ['manager'],
    },
  },
  {
    path: 'crm',
    children: [
      // {
      //   path: '',
      //   loadChildren: () =>
      //     import('../../crm/pages/home-page/home-page.module').then(
      //       (m) => m.HomePageModule
      //     ),
      // },
      // {
      //   path: 'home',
      //   loadChildren: () =>
      //     import('../../crm/pages/home-page/home-page.module').then(
      //       (m) => m.HomePageModule
      //     ),
      // },
      // {
      //   path: 'payments',
      //   loadChildren: () =>
      //     import('../../crm/pages/payments-page/payments-page.module').then(
      //       (m) => m.PaymentsPageModule
      //     ),
      // },
      // {
      //   path: 'leads',
      //   loadChildren: () =>
      //     import('../../crm/pages/leads-page/leads-page.module').then(
      //       (m) => m.LeadsPageModule
      //     ),
      // },
      // {
      //   path: 'zoom',
      //   loadChildren: () =>
      //     import(
      //       '../../crm/pages/zoom-meetings-page/zoom-meetings-page.module'
      //     ).then((m) => m.ZoomMeetingsPageModule),
      // },
      // {
      //   path: 'online-payments',
      //   loadChildren: () =>
      //     import(
      //       '../../crm/pages/online-payments-page/online-payments-page.module'
      //     ).then((m) => m.OnlinePaymentsPageModule),
      // },
      {
        path: 'data',
        loadChildren: () =>
          import('../../crm/pages/data-page/data-page.module').then((m) => m.DataPageModule),
      },
      {
        path: 'group',
        loadChildren: () =>
          import('../../crm/pages/group-page/group-page.module').then((m) => m.GroupPageModule),
      },
      {
        path: 'student',
        loadChildren: () =>
          import('../../crm/pages/student-page/student-page.module').then(
            (m) => m.StudentPageModule,
          ),
      },
      // {
      //   path: 'teacher',
      //   loadChildren: () =>
      //     import('../../crm/pages/teacher-page/teacher-page.module').then(
      //       (m) => m.TeacherPageModule
      //     ),
      // },
      // {
      //   path: 'schedule',
      //   loadChildren: () =>
      //     import('../../crm/pages/schedule-page/schedule-page.module').then(
      //       (m) => m.SchedulePageModule
      //     ),
      // },
      // {
      //   path: 'salary-list',
      //   loadChildren: () =>
      //     import(
      //       '../../crm/pages/salary-list-page/salary-list-page.module'
      //     ).then((m) => m.SalaryListPageModule),
      // },
      // {
      //   path: 'competitions',
      //   loadChildren: () =>
      //     import(
      //       '../../crm/pages/competitions-page/competitions-page.module'
      //     ).then((m) => m.CompetitionsPageModule),
      // },
    ],
  },
  // {
  //   path: 'olympiads',
  //   loadChildren: () =>
  //     import('../olympiads/olympiads.module').then(
  //       (mod) => mod.OlympiadsModule
  //     ),
  // },
  // {
  //   path: 'create-olympiad',
  //   loadChildren: () =>
  //     import('../olympiads/create-olympiad/create-olympiad.module').then(
  //       (m) => m.CreateOlympiadModule
  //     ),
  // },
  {
    path: 'qna',
    loadChildren: () => import('../qna/qna.component.module').then((m) => m.QnaModule),
  },
  {
    path: 'subscriptions',
    loadChildren: () =>
      // UserTypeGuard по каким-то не понятным мне причинам
      // переводит тип superuser в admin (??????????)
      // из-за чего невозможно просто поставить userTypes: ['superuser']
      // и вместо этого надо в конструкторе проверять и редиректить вручную
      // (исправлять я это боюсь, вдруг тут какая-то фигня на это полагается)
      import('../subscriptions/subscriptions.module').then((m) => m.SubscriptionsModule),
  },
  {
    path: 'subscriptions-statistics',
    loadChildren: () =>
      import('../subscriptions-statistics/subscriptions-statistics.module').then(
        (m) => m.SubscriptionStatisticsModule,
      ),
  },
  {
    path: 'homeworks-statistics',
    loadChildren: () =>
      import('../superuser-homeworks-statistics/superuser-homeworks-statistics.module').then(
        (m) => m.SuperuserHomeworksStatisticsModule,
      ),
  },
  {
    path: 'payments-statistics',
    loadChildren: () =>
      import('../superuser-payments-statistics/superuser-payments-statistics.module').then(
        (m) => m.SuperuserPaymentsStatisticsModule,
      ),
  },
  {
    path: 'newcomers-statistics',
    loadChildren: () =>
      import('../superuser-newcomers-statistics/superuser-newcomers-statistics.module').then(
        (m) => m.SuperuserNewcomersStatisticsModule,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MgtRoutingModule {}
